<template>
  <div class="message-box">
    <div class="message-box__icon">
      <ChargeSvg v-if="icon == 'charge'" />
      <UnchargeSvg v-if="icon == 'uncharge' " />
      <AutoSvg v-if="icon == 'auto'" />
    </div>
    <div class="message-box__text">
      <div class="message-box__title">
        <h3>{{title}}</h3>
      </div>
      <div class="message-box__content">
        <p>{{content}}</p>
      </div>
    </div>
    <div class="message-box__arrow"></div>
  </div>
</template>

<script>
import ChargeSvg from '@/assets/icon/charge.svg';
import UnchargeSvg from '@/assets/icon/uncharge.svg';
import AutoSvg from '@/assets/icon/auto.svg';

export default {
  name: "MessageBox",
  props: {
    title: String,
    content: String,
    icon: String
  },
  components: {
    ChargeSvg,
    UnchargeSvg,
    AutoSvg
  }
}
</script>

<style lang="scss">

#photovoltaics{
  .message-box{
    grid-column: 1 / 3;
    grid-row: 7;
    @include media-breakpoint-up(md) {
      grid-column: 1;
      grid-row: 3;
    }

    align-self: end;
    min-height: 110px;

    margin-top: 20px;

    position: relative;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 10px;
    text-align: center;
    background: $yellow-light;
    $_border: 3px;
    border: solid $_border transparent;
    background-clip: padding-box;

    &__title{
      margin-top: 0.5rem;
      h3{
        font-size: 16px;
        font-weight: bold;
      }
    }
    &__content{
      font-size: 12px;
    }
    &__arrow{
      display: none;
    }

    $_arrow_width: 20px;
    @include media-breakpoint-up(md) {
      display: flex;

      margin-right: 10px;

      &__icon{
        width: 120px;
        margin-top: 20px;
        margin-right: 1rem;
      }
      &__text{
        flex-grow: 1;
        text-align: left;
      }

      &__arrow, &:after{
        display: block;
        position: absolute;
        height: 100px;
        width: $_arrow_width;
        top: 50%;
        transform: translateY(-50%);
        right: 1px - $_arrow_width;
        border-left: $_arrow_width solid $yellow-light;
        border-bottom: 50px solid transparent;
        border-top: 50px solid transparent;

        box-sizing: border-box;
        z-index: 3;
      }
      &:after{
        z-index: 2;
        content: ' ';
        border-left-color: $yellow-gradient-right;
        width: $_arrow_width;
        right: -2px - $_arrow_width;
      }
    }
    @include media-breakpoint-up(lg) {

      margin-right: 25px;

    }
    @include media-breakpoint-up(xl) {
      margin-right: 25px;
      margin-left: 20px;

      &__icon{
        margin-top: 0;
        align-self: center;
      }
      &__arrow, &:after{
        height: 50px;
        border-bottom-width: 25px;
        border-top-width: 25px;
      }
      &:after{
        right: -3px - $_arrow_width;
      }
    }

    &:before {
      content: '';
      position: absolute;
      top: 0; right: 0; bottom: 0; left: 0;
      z-index: -1;
      margin: -$_border;
      border-radius: inherit;
      background: linear-gradient(to right, $yellow-gradient-left, $yellow-gradient-right);
    }
  }
}
</style>
